<!-- View for chit-chatting -->
<template>
	<div
		class="relative h-full w-full place-content-center"
		@click="onTap"
	>
		<SbMedia
			v-if="background"
			:blok="background"
			:active="active"
		></SbMedia>

		<div
			class="absolute top-1/2 left-1/2 flex h-[24vh] w-full -translate-x-1/2 -translate-y-1/2 justify-center"
			:class="useWhiteLogoBackground ? 'bg-white' : ''"
		>
			<img :src="logo" />
		</div>
	</div>
</template>

<script setup lang="ts">
import SbMedia from '@/components/blocks/SbMedia.vue'
import type { SbMediaStoryblok, FuneralHomeLogoSlideStoryblok } from '@/sbTypes'
import { useAssetStore } from '@/stores/asset'
import { useFuneralHomeGroupMediaController } from '@/stores/funeralHomeGroupMediaController'
import { usePresentationController } from '@/stores/presentationController'
import { useSessionStore } from '@/stores/session'
import { asyncComputed } from '@vueuse/core'
import { Swiper } from 'swiper'
import { computed, type PropType } from 'vue'

const assetStore = useAssetStore()
const sessionStore = useSessionStore()
const presentationController = usePresentationController()
const fhController = useFuneralHomeGroupMediaController()

const props = defineProps({
	blok: Object as PropType<FuneralHomeLogoSlideStoryblok>,
	parentSwiper: Swiper,
	active: Boolean,
})

const activeFhMedia = computed(() => sessionStore.activeFhMedia)

const background = computed<SbMediaStoryblok | undefined>(() => {
	// fetch from activeFhMedia and if no background in media group then use fallback prop
	return activeFhMedia.value?.warmUpBackground ?? props.blok?.background?.[0]
})

const logo = activeFhMedia.value?.logo

/** Take the FH's value for white logo background stripe if they have their own warm-up background */
const useWhiteLogoBackground = computed(() => {
	return activeFhMedia.value?.warmUpBackground
		? activeFhMedia.value.useWhiteLogoBackground
		: props.blok?.whiteLogoBackground
})

function onTap() {
	presentationController.gotoNextSlide()
	fhController.gotoNextSlide()
}
</script>
